import React, { memo, useEffect, useState } from 'react'
import { Button, HeadingText, CriticalIcon } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import DsrBanner from '../common/dsr-banner'
import { fptiCustomSetup, fptiCustomClick } from '../../../utils'

const VerificationError = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { dsrFpti = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(dsrFpti.EMAILVERIFICATION_ERROR_IMPRESSION)
    }
  }, [impressionDone, dsrFpti])
  const bannerContent = {
    header: <Message id="dsrZettle.confirm.email.title" />,
    description: '',
  }
  const onClickRetry = (evt) => {
    evt.preventDefault()
    fptiCustomClick(dsrFpti.EMAILVERIFICATION_RETRY_BTN)
    props.changeState('VERIFY')
  }
  return (
    <>
      <DsrBanner {...bannerContent} />
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen">
            <div className="text-center">
              <CriticalIcon className="icon-block critical" />
            </div>
            <HeadingText size="sm" className="text-center">
              <Message id="dsrZettle.confirm.email.body.error" />
            </HeadingText>

            <div className="button-container">
              <Button size="sm" onClick={onClickRetry} secondary>
                <Message id="dsrZettle.common.error.try.again" />
              </Button>
            </div>
          </section>
        </div>
      </section>
    </>
  )
})
VerificationError.displayName = 'VerificationError'

export default VerificationError
